import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {
    const vpSections = document.querySelectorAll('.video-promo');
    const header = document.querySelector('header.main-header');

    let headerHeight = header ? header.offsetHeight : 0;

    function updateHeaderHeight() {
        headerHeight = header ? header.offsetHeight : 0;
        vpSections.forEach(section => {
            section.style.setProperty('--header-height', `${headerHeight}px`);
        });
    }

    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);

    // === Initialize Scroll Animation for Each .video-promo Section ===
    function initScrollAnimations() {
        vpSections.forEach((section, index) => {
            const slider = section.querySelector('.vp-wrap');
            const wrapper = slider?.querySelector('.vp-list');
            const items = wrapper?.querySelectorAll('.vp-item');

            if (!slider || !wrapper || !items || items.length <= 1) {return;}

            // Give each section & trigger a unique ID
            const triggerId = `videoPromoTrigger_${index}`;
            section.setAttribute('data-scroll-id', triggerId);

            // Kill any existing trigger for this section
            ScrollTrigger.getAll().forEach(trigger => {
                if (trigger.vars?.id === triggerId) {trigger.kill();}
            });

            const totalContentWidth = wrapper.scrollWidth;
            const sliderWidth = slider.offsetWidth;
            const totalScroll = totalContentWidth - sliderWidth;
            const adjustedHeaderHeight = header ? header.offsetHeight + 10 : 0;

            gsap.to(wrapper, {
                x: -totalScroll,
                ease: 'none',
                scrollTrigger: {
                    id: triggerId, // unique trigger id
                    trigger: section,
                    start: `top ${adjustedHeaderHeight}`,
                    end: `+=${totalScroll}`,
                    scrub: 1,
                    pin: true,
                    anticipatePin: 1,
                    // markers: true,
                },
            });
        });
    }

    // === Responsive handling ===
    function handleResponsiveScroll() {
        if (window.innerWidth > 991) {
            initScrollAnimations();
        } else {
            ScrollTrigger.getAll().forEach(trigger => trigger.kill());
        }
    }

    handleResponsiveScroll();

    // === Debounced resize ===
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            updateHeaderHeight();
            handleResponsiveScroll();
        }, 200);
    });
});
